import { render, staticRenderFns } from "./cardDocuments.vue?vue&type=template&id=17aebed2&scoped=true&"
import script from "./cardDocuments.vue?vue&type=script&lang=js&"
export * from "./cardDocuments.vue?vue&type=script&lang=js&"
import style0 from "./cardDocuments.vue?vue&type=style&index=0&id=17aebed2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aebed2",
  null
  
)

export default component.exports